import React, { FunctionComponent } from 'react'

import LottieView from 'lottie-react-native'
import styled from 'styled-components/native'

const Container = styled.View<{ size: number }>(({ size }) => ({
  width: `${size}px`,
  height: `${size}px`,
}))

type AuroraOrbIllustrationProps = {
  size?: number
}

export const AuroraOrbIllustration: FunctionComponent<AuroraOrbIllustrationProps> = ({ size = 284 }) => {
  return (
    <Container size={size}>
      <LottieView
        source={require('../../assets/lottie/loading-results_orb-soft-thinking.json')}
        autoPlay
        loop={false}
        duration={5000}
        style={{ width: size, height: size }}
      />
    </Container>
  )
}
